let button = $('.hamburger-menu');
let menu = $('.header-nav');
let body = $('body');
let menuItem = $('.header-menu li');

function updatedSimpleBanner() {
  var _sb = $('#simple-banner');
  if (_sb.length) {
    _sb.height('auto');
    _sb.height(_sb.height());
  }
}

export function openResponsiveMenu() {
  setTimeout(() => {
    updatedSimpleBanner();
  }, 500);

  menuItem.on('click', '.event-none, .chevron-arrow', function (event) {
    event.preventDefault();
  });

  button.on('click', function (event) {
    event.preventDefault();

    $(this).toggleClass('open');

    if (menu.hasClass('open')) {
      setTimeout(() => {
        menu.toggleClass('open');
      }, 100);
      menu.toggleClass('opened');
      menuItem.removeClass('open');
      $('.mega-menu, .submenu').removeClass('open-mobile').hide();
    } else {
      setTimeout(() => {
        menu.toggleClass('opened');
      }, 100);
      menu.toggleClass('open');
    }

    body.toggleClass('menu-open');

    if (body.hasClass('menu-open')) {
      [...menuItem].forEach((element) => {
        if ($(element).find('.categorized-links').length) {
          $(element).toggleClass('open');
          $('.categorized-links').show();
        }
      });
    } else {
      $('.btn-back').removeClass('active');
      $('#menu-mega-menu').removeClass('submenu-open');
      $('.categorized-links > div > div').removeClass('active');
    }
  });

  [...menuItem].forEach((element) => {
    if ($(element).find('.submenu, .mega-menu, .categorized-links').length) {
      $(element).children('a').addClass('chevron-arrow');
    }
  });

  if ($(window).outerWidth() >= 768) {
    $(document).click(function (event) {
      const $menu = $('#menu-mega-menu');
      if ($menu.has(event.target).length === 0) {
        $(menuItem).removeClass('open');
      }
    });

    [...menuItem].forEach((element) => {
      if ($(element).find('.submenu, .mega-menu, .categorized-links').length) {
        $(element).click(function (event) {
          if (event.target.parentNode === element) {
            const isActive = $(this).hasClass('open');
            $(menuItem).removeClass('open');

            if (!isActive) {
              $(this).addClass('open');
            }
          }
        });
      }
    });
  } else {
    $(window).trigger('scroll');

    menuItem.on('click', '.chevron-arrow, .event-none', function (event) {
      event.preventDefault();
      const $parent = $(this).parent('li');
      const $header = $parent.parent('ul.header-menu');
      $('html, body').animate({ scrollTop: 0 }, 'fast');

      if ($parent.find('.categorized-links').length) {
        return;
      }

      $(this)
        .parent('li')
        .toggleClass('open')
        .find('.submenu, .mega-menu')
        .addClass('open-mobile');

      if (!$parent.find('.categorized-links').length) {
        if ($parent.hasClass('open')) {
          $('.btn-back').addClass('active');
          $header.addClass('submenu-open');
        } else {
          $('.btn-back').removeClass('active');
          $header.removeClass('submenu-open');
        }
      }
    });

    var _h = $(window).height();
    menu.css('max-height', _h + 'px');

    window.onresize = function (event) {
      _h = $(window).height();
      $('.header-nav').css('max-height', _h + 'px');
    };
  }

  if ($(document).find('.categorized-links').length) {
    function activateCategorizedMenu() {
      console.log(
        this,
        $(`#${$(this).data('referenced-group')}`).length > 0,
        $(`#${$(this).data('referenced-group')}`)
      );
      if ($(`#${$(this).data('referenced-group')}`).length > 0) {
        $('.categorized-links > div > div').removeClass('active');
        $('.categorized-links > ul > li').removeClass('active');
        $(this).addClass('active');
        $(`#${$(this).data('referenced-group')}`).addClass('active');

        if ($(window).outerWidth() <= 768) {
          $('.btn-back').addClass('active');
          $('#menu-mega-menu').addClass('submenu-open');
          $('html, body').animate({ scrollTop: 0 }, 'fast');
        }
      }

    }

    $(document)
      .find('.categorized-links > ul > li')
      .each((index, category) => {
        if ($(window).outerWidth() >= 768) {
          if (index === 0) {
            const referencedGroup = $(category).data('referenced-group');
            $(category).addClass('active');
            $(`#${referencedGroup}`).addClass('active');
          }
        }
        $(category).click(activateCategorizedMenu);
      });

    $(document)
      .find('.btn-back')
      .each((_, button) => {
        $(button).click(function () {
          $('.categorized-links > div > div').removeClass('active');
          $(button).removeClass('active');
          $('#menu-mega-menu').removeClass('submenu-open');
          $('.header-menu li:not(:has(.categorized-link))').removeClass('open');
          $('.header-menu li:has(.categorized-links)').addClass('open');
          $('.mega-menu, .submenu').removeClass('open-mobile').hide();
          $('.categorized-links').show();
        });
      });
  }

  window.onresize = function (event) {
    updatedSimpleBanner();
  };
}



// WEBPACK FOOTER //
// ./assets/js/modules/headerMenu.js